import React from 'react';
import PropTypes from 'prop-types';
import BurstButton from 'common/components/BurstButton';

const SAVE_LABEL = 'Save';
const OFFLINE_LABEL = 'Offline';
const SAVED_LABEL = 'Saved';
const BASE_CLASS_NAME = 'WorkspaceTopbarSaveButton';

const WorkspaceTopbarSaveButton = ({ className, isSaving, onClick, hasSaveError, ...buttonProps }) => (
    <BurstButton
        className={`${className} ${BASE_CLASS_NAME}`}
        label={SAVE_LABEL}
        offlineLabel={OFFLINE_LABEL}
        labelDone={SAVED_LABEL}
        isLoading={isSaving}
        onClick={onClick}
        hasSaveError={hasSaveError}
        data-qa="WORKSPACE_SAVE_BUTTON"
        {...buttonProps}
    />
);

WorkspaceTopbarSaveButton.propTypes = {
    isSaving: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string,
    hasSaveError: PropTypes.bool,
};

WorkspaceTopbarSaveButton.defaultProps = {
    className: '',
    hasSaveError: false,
};

export default WorkspaceTopbarSaveButton;
